





















import { Component, Vue } from "vue-property-decorator";
import ScEmergencyList from "@/components/sc-emergency/ScEmergencyList.vue";
import ScEmergencyDashboard from "@/components/sc-emergency/ScEmergencyDashboard.vue";
import ScEmergencyMonthlyReport from "@/components/sc-emergency/ScEmergencyMonthlyReport.vue";

@Component({
  components: { ScEmergencyList, ScEmergencyDashboard, ScEmergencyMonthlyReport }
})
export default class ScEmergencyPage extends Vue {
  tab = 0;
}
